export default __webpack_public_path__ + "static/media/gallery-bg.ced41489.png";